import { TQueueModalState } from '../reducers/queueModalReducer';
import { TAction } from './types/action';
// Action Types
export const SET_QUEUE_MODAL_ERROR = 'SET_QUEUE_MODAL_ERROR';
export const CLEAR_QUEUE_MODAL_ERROR = 'CLEAR_QUEUE_MODAL_ERROR';
export const SET_QUEUE_MODAL_TAB = 'SET_QUEUE_MODAL_TAB';
export const SET_QUEUE_MODAL_IS_LOADING = 'SET_QUEUE_MODAL_IS_LOADING';
export const SET_QUEUE_MODAL_IS_OPEN = 'SET_QUEUE_MODAL_IS_OPEN';
export const SET_QUEUE_MODAL_PARAMS = 'SET_QUEUE_MODAL_PARAMS';
// Action Creators
export type TError = {
  type?: string;
  title: string;
  body?: string;
};

export type TQueueModalTab = 'guild' | 'character' | 'dungeon';

export type TErrorAction = TAction<TError>;
export type TSetErrorVisibleAction = TAction<boolean>;

export function createActionSetQueueModalError(error: TError): TErrorAction {
  return {
    type: SET_QUEUE_MODAL_ERROR,
    payload: error
  };
}

export function createActionClearQueueModalError() {
  return {
    type: CLEAR_QUEUE_MODAL_ERROR
  };
}

export function createActionSetQueueModalTab(tab: TQueueModalTab) {
  return {
    type: SET_QUEUE_MODAL_TAB,
    payload: tab
  };
}

export function createActionSetQueueModalIsLoading(isLoading: boolean) {
  return {
    type: SET_QUEUE_MODAL_IS_LOADING,
    payload: isLoading
  };
}

export function createActionSetQueueModalIsOpen(isOpen: boolean) {
  return {
    type: SET_QUEUE_MODAL_IS_OPEN,
    payload: isOpen
  };
}

export function createActionSetQueueModalParams(params: Partial<TQueueModalState>) {
  return {
    type: SET_QUEUE_MODAL_PARAMS,
    payload: params
  };
}
